import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tab-collection" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "actions" }
const _hoisted_4 = { class: "galleries" }
const _hoisted_5 = {
  key: 0,
  class: "empty-data"
}
const _hoisted_6 = { class: "header" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "actions" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "images" }
const _hoisted_12 = {
  key: 0,
  class: "empty-data"
}
const _hoisted_13 = {
  key: 1,
  class: "list"
}
const _hoisted_14 = { class: "avatar" }
const _hoisted_15 = ["src", "onClick"]
const _hoisted_16 = { class: "actions" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 0,
  class: "empty-data"
}

import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import store from "@/store";

import { toast } from "@/common/utils/toast";

import {
  collectionGalleryList,
  collectionGalleryCreate,
  collectionGalleryPatch,
  collectionGalleryDel,
  collectionGalleryFileList,
  collectionGalleryFileCreate,
  collectionGalleryFileRemove,
} from "@/common/api/rest/collection-gallery";

import type { AvatarType } from "@/common/types/common";
import type { TranslationFieldsType } from "@/common/types/translation";
import type { CollectionType } from "@/common/types/collection";
import type {
  CollectionGalleryType,
  CollectionGalleryPayloadType,
} from "@/common/types/collection-gallery";

import { FormGallery, ListTranslate } from "@/components";

import {
  baseAvatar,
  baseConfirm,
  baseModal,
  baseSidebar,
  baseLoading,
  cropImage,
  svgIcon,
  viewImage,
  viewImageList,
} from "@/common/components";

const ratio = 1.333;
const imageSize = "15rem";


export default /*@__PURE__*/_defineComponent({
  __name: 'gallery',
  props: {
    collection: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v78d6f1e0": (imageSize),
  "v0ce3fbef": (ratio)
}))

const { t, locale } = useI18n();

const props = __props;

const galleries = ref<CollectionGalleryType[]>([]);
const images = ref<{ [key: string]: AvatarType[] }>({});

const payloadGallery = ref<CollectionGalleryPayloadType | null>(null);
const selectedGallery = ref<CollectionGalleryType | null>(null);
const selectedImage = ref<string | null>(null);
const selectedImageList = ref<string[]>([]);
const selectedImageIndex = ref<number | null>(null);

const loading = ref(false);
const showImage = ref(false);
const showModalAdd = ref(false);
const showModalEdit = ref(false);
const showModalDel = ref(false);
const showModalAddImage = ref(false);
const showModalDelImage = ref(false);

const translationFields = ref<TranslationFieldsType[]>([
  {
    type: "input",
    field: "name",
    label: "common.labels.name",
    value: "",
  },
]);

// files
async function fetchFiles(itemId: string) {
  await collectionGalleryFileList(itemId, { type: props.collection.type })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        images.value[itemId] = data.list;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

// gallery
async function fetchGallery() {
  await collectionGalleryList(props.collection.collection_id, {
    full: true,
  })
    .then((response) => {
      const { success, message } = response;

      if (success) {
        galleries.value = response.data.list;

        galleries.value.forEach((item) => {
          fetchFiles(item.item_id);
        });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function addGallery() {
  showModalAdd.value = true;
}

function addGalleryCancel() {
  payloadGallery.value = null;
  showModalAdd.value = false;
}

function addGalleryConfirm() {
  if (!payloadGallery.value) return;

  showModalAdd.value = false;

  collectionGalleryCreate(props.collection.collection_id, payloadGallery.value)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        fetchGallery();
        editGallery(data);
        addGalleryCancel();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      showModalAdd.value = true;
      toast({ message: t("error.default"), type: "error" });
    });
}

function editGallery(item: CollectionGalleryType) {
  selectedGallery.value = item;
  showModalEdit.value = true;
}

function editGalleryCancel() {
  selectedGallery.value = null;
  showModalEdit.value = false;
}

function editGalleryPatch(payload: Partial<CollectionGalleryType>) {
  if (!selectedGallery.value) return;

  collectionGalleryPatch(selectedGallery.value.item_id, payload)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchGallery();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      showModalEdit.value = true;
      toast({ message: t("error.default"), type: "error" });
    });
}

function delGallery(item: CollectionGalleryType) {
  selectedGallery.value = item;
  showModalDel.value = true;
}

function delGalleryCancel() {
  selectedGallery.value = null;
  showModalDel.value = false;
}

function delGalleryConfirm() {
  if (!selectedGallery.value) return;

  collectionGalleryDel(selectedGallery.value.item_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchGallery();
        delGalleryCancel();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

// image
function addGalleryImage(item: CollectionGalleryType) {
  selectedGallery.value = item;
  showModalAddImage.value = true;
}

function addGalleryImageCancel() {
  selectedGallery.value = null;
  showModalAddImage.value = false;
}

async function addGalleryImageConfirm(file: string) {
  showModalAddImage.value = false;

  store.commit("SET_LOADING", true);

  collectionGalleryFileCreate(
    props.collection.collection_id,
    selectedGallery.value.item_id,
    file
  )
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchFiles(selectedGallery.value.item_id);
        addGalleryImageCancel();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      showModalAdd.value = true;
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

function removeGalleryImage(item: CollectionGalleryType, fileId: string) {
  selectedGallery.value = item;
  selectedImage.value = fileId;
  showModalDelImage.value = true;
}

function removeGalleryImageCancel() {
  selectedGallery.value = null;
  selectedImage.value = null;
  showModalDelImage.value = false;
}

async function removeGalleryImageConfirm() {
  showModalDelImage.value = false;

  store.commit("SET_LOADING", true);

  await collectionGalleryFileRemove(
    selectedGallery.value.item_id,
    selectedImage.value
  )
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchFiles(selectedGallery.value.item_id);
        removeGalleryImageCancel();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

function galleryImageShow(item_id: string, index: number) {
  // selectedImage.value = url;
  selectedImageList.value = images.value[item_id]?.map((item) => item.large);
  selectedImageIndex.value = index;
  showImage.value = true;
}

function galleryImageCancel() {
  selectedImage.value = null;
  selectedImageIndex.value = null;
  showImage.value = false;
}

onMounted(async () => {
  loading.value = true;
  await fetchGallery();
  loading.value = false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "btn btn-md btn-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (addGallery()))
          }, [
            _createVNode(_unref(svgIcon), {
              icon: "add",
              size: "1.5rem"
            }),
            _createElementVNode("span", null, _toDisplayString(_unref(t)("collection.labels.add_gallery")?.toUpperCase()), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_unref(baseLoading))
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(galleries.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.item_id,
                    class: "gallery"
                  }, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(item.name), 1),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("button", {
                          class: "btn btn-transparent w-9 h-9 p-0",
                          onClick: ($event: any) => (editGallery(item))
                        }, [
                          _createVNode(_unref(svgIcon), {
                            icon: "edit",
                            size: "1.5rem"
                          })
                        ], 8, _hoisted_9),
                        _createElementVNode("button", {
                          class: "btn btn-transparent w-9 h-9 p-0",
                          onClick: ($event: any) => (delGallery(item))
                        }, [
                          _createVNode(_unref(svgIcon), {
                            icon: "trash",
                            size: "1.5rem"
                          })
                        ], 8, _hoisted_10)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      (!images.value[item.item_id]?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(t)("collection.texts.empty_images")), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images.value[item.item_id], (image, imageIndex) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: image.id,
                                class: "image"
                              }, [
                                _createElementVNode("div", _hoisted_14, [
                                  _createElementVNode("img", {
                                    src: image.small,
                                    onClick: ($event: any) => (galleryImageShow(item.item_id, imageIndex))
                                  }, null, 8, _hoisted_15)
                                ]),
                                _createElementVNode("div", _hoisted_16, [
                                  _createElementVNode("button", {
                                    class: "btn btn-transparent w-9 h-9 p-0",
                                    onClick: ($event: any) => (removeGalleryImage(item, image.id))
                                  }, [
                                    _createVNode(_unref(svgIcon), {
                                      icon: "trash",
                                      size: "1.5rem"
                                    })
                                  ], 8, _hoisted_17)
                                ])
                              ]))
                            }), 128))
                          ])),
                      _createElementVNode("button", {
                        class: "btn btn-md btn-primary",
                        onClick: ($event: any) => (addGalleryImage(item))
                      }, [
                        _createVNode(_unref(svgIcon), {
                          icon: "add",
                          size: "1.25rem"
                        }),
                        _createElementVNode("span", null, _toDisplayString(_unref(t)("collection.labels.image")?.toUpperCase()), 1)
                      ], 8, _hoisted_18)
                    ])
                  ]))
                }), 128)),
                (!galleries.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_unref(t)("collection.texts.empty_gallery")), 1))
                  : _createCommentVNode("", true)
              ], 64))
        ])
      ])
    ]),
    (showModalAddImage.value)
      ? (_openBlock(), _createBlock(_unref(cropImage), {
          key: 0,
          onChange: _cache[1] || (_cache[1] = ($event: any) => (addGalleryImageConfirm($event))),
          onCancel: _cache[2] || (_cache[2] = ($event: any) => (addGalleryImageCancel()))
        }))
      : _createCommentVNode("", true),
    (showImage.value)
      ? (_openBlock(), _createBlock(_unref(viewImageList), {
          key: 1,
          images: selectedImageList.value,
          selected: selectedImageIndex.value,
          onClose: galleryImageCancel
        }, null, 8, ["images", "selected"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(baseModal), {
      show: showModalAdd.value,
      title: _unref(t)('collection.modals.titles.add_gallery').toUpperCase(),
      "show-button-confirm": true,
      "button-confirm": _unref(t)('common.labels.save'),
      "button-close": _unref(t)('common.labels.cancel'),
      onClose: _cache[4] || (_cache[4] = ($event: any) => (addGalleryCancel())),
      onConfirm: _cache[5] || (_cache[5] = ($event: any) => (addGalleryConfirm()))
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(FormGallery), {
          "onUpdate:data": _cache[3] || (_cache[3] = ($event: any) => (payloadGallery.value = $event))
        })
      ]),
      _: 1
    }, 8, ["show", "title", "button-confirm", "button-close"]),
    (showModalEdit.value && selectedGallery.value)
      ? (_openBlock(), _createBlock(_unref(baseSidebar), {
          key: 2,
          width: _ctx.$store.getters.mobile ? '90vw' : '60vw',
          open: true,
          "outside-close": true,
          onClose: _cache[7] || (_cache[7] = ($event: any) => (editGalleryCancel()))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(FormGallery), {
              data: selectedGallery.value,
              "is-patch": true,
              "onUpdate:data": _cache[6] || (_cache[6] = ($event: any) => (editGalleryPatch($event)))
            }, null, 8, ["data"]),
            _createVNode(_unref(ListTranslate), {
              "owner-id": selectedGallery.value.item_id,
              language: _unref(locale).toLowerCase(),
              fields: translationFields.value
            }, null, 8, ["owner-id", "language", "fields"])
          ]),
          _: 1
        }, 8, ["width"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(baseConfirm), {
      show: showModalDel.value,
      title: _unref(t)('collection.modals.titles.del_gallery').toUpperCase(),
      message: 
      _unref(t)('collection.modals.messages.del_gallery', {
        name: selectedGallery.value?.name?.toUpperCase(),
      })
    ,
      onCancel: _cache[8] || (_cache[8] = ($event: any) => (delGalleryCancel())),
      onConfirm: _cache[9] || (_cache[9] = ($event: any) => (delGalleryConfirm()))
    }, null, 8, ["show", "title", "message"]),
    _createVNode(_unref(baseConfirm), {
      show: showModalDelImage.value,
      title: _unref(t)('collection.modals.titles.del_image').toUpperCase(),
      message: 
      _unref(t)('collection.modals.messages.del_image', {
        name: selectedGallery.value?.name?.toUpperCase(),
      })
    ,
      onCancel: _cache[10] || (_cache[10] = ($event: any) => (removeGalleryImageCancel())),
      onConfirm: _cache[11] || (_cache[11] = ($event: any) => (removeGalleryImageConfirm()))
    }, null, 8, ["show", "title", "message"])
  ], 64))
}
}

})